// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Toggle_wrapper__ASc6z","label":"Toggle_label__XgCII"};